import React from "react"
import { GroupModel } from "../../../models/organisation/GroupModel"
import { ReactComponent as Pempem } from "../../../rsc/logo_pempem.svg";
import { Suppliers } from "../../../models/organisation/Suppliers";
import { colorLightGrey } from "../../../rsc/colors/colors";
import { t } from "i18next";
import { isArrayNullOrEmpty } from "../../../helper/helper";
import { ReactComponent as PemBoySad } from "../../../rsc/pemboy_sad.svg";
import { Tooltip } from "@mui/material";
import { EmptyView } from "../../../components/EmptyView";

type Props = {
    suppliers: Suppliers
}

export const GroupSupplier = ({ suppliers }: Props) => {


    const GroupElement: React.FC<{ group: GroupModel }> = ({ group }) => {
        return (
            <div className="pempem-flex-col gap10" style={{ width: '350px' }}>
                <div className="pempem-flex-row-rev gap10">
                    <Tooltip title={group.name}>
                        <span style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className="font-20 bold">{group.name}</span>
                    </Tooltip>
                    <span className="font-20 bold">{t('size')}</span>
                </div>
                <div className="pempem-flex-col gap5">
                    {!isArrayNullOrEmpty(group.farmers) ? group.farmers.map(f => <div key={f.person.id} className="pempem-flex-row padding10 gap10" style={{ background: colorLightGrey(), alignItems: 'center' }}>
                        <div className="pempem-flex-col gap5" style={{ flex: 1 }}>
                            <span className="font-normal bold primaryDarkColor">{f.person?.getFullName()}</span>
                            {
                                f.person?.location &&
                                <>
                                    <span className="primaryDarkColor">{f.person?.location?.village}, {f.person?.location?.district}</span>
                                    <span className="primaryDarkColor">{f.person?.location?.province}</span>
                                </>
                            }
                        </div>
                        <span className="font-20 bold">{f.plotsSize()} ha</span>
                    </div>) :
                        <EmptyView type="check" isVisible={true} title={t('no_farmer_for_group')} />
                    }
                </div>
            </div>)
    }

    return (
        <div>
            <div className="pempem-flex-row-center" style={{ width: 'fit-content' }}>
                <div className="pempem-flex-col-center">
                    <Pempem fill={'red'} />
                    <span className="bold">hakam</span>
                </div>
                <span className="font-28 bold" style={{ marginLeft: '30px' }}>{suppliers.mill?.name}</span>
            </div>
            <div style={{ marginTop: '30px', flexWrap: 'wrap', gap: 36 }} className="pempem-flex-row">
                {
                    suppliers.groups?.map(g => <GroupElement key={g.id} group={g} />)
                }
            </div>
        </div>
    )
}